import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpHeaders,HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginResetPasswordService {

  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    
  }
  setToken(token){
    this.authService.setPasswordToken(token);
  }
  buscarCorreo(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.buscarCorreo ,datos);
  }
  searchToken(token){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.buscarToken );
      
    /*return this.http.get(DATOS_API.url + DATOS_API.endpoints.buscarToken,
      { headers: new HttpHeaders({
      
                 'Authorization': "bearer " + token
      })});*/
   
  }

  actualizarUsuario(datos){
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateUser_ ,datos);
  }

  actualizaUsuariosEmpresas(iduser:any,datos:any,token){
    console.log(datos);
    //return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaInfoUsuarioEmpresa+iduser,datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaInfoUsuarioEmpresa+iduser,datos,
    { headers: new HttpHeaders({'Token': token })});
    
  }
  



  

}
